var $c0650163dc1b6f9d$exports = {};
$c0650163dc1b6f9d$exports = {
  "removeButtonLabel": "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435",
  "removeDescription": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 Delete, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0435\u0442\u0435 \u043C\u0430\u0440\u043A\u0435\u0440\u0430."
};
export { $c0650163dc1b6f9d$exports as default };